function ActiveEventsController(
  EventsService,
  userService,
  $uibModal,
  $interval
) {
  const ctrl = this;

  ctrl.$onInit = () => {
    ctrl.contentAreaId = 'div#eventsList';
    ctrl.sortType = 'activated';
    ctrl.listSort = 'consist';
    ctrl.sortReverse = true;
    ctrl.listSortReverse = false;
    ctrl.selectedConsists = [];
    ctrl.dataLoading = false;
    ctrl.events = [];
    ctrl.accordionStatus = null;
    ctrl.hasActiveEventRead = userService.hasActiveEventRead();
    if (ctrl.hasActiveEventRead) {
      ctrl.loadEvents();
      startPoll();
    }
  };

  ctrl.$onDestroy = () => {
    $interval.cancel(ctrl.dataFetchPromise);
  };

  ctrl.setSortType = column => {
    if (ctrl.dataLoading) return;
    ctrl.sortReverse = (ctrl.sortType === column) ? !ctrl.sortReverse : false;
    ctrl.sortType = column;
  };

  ctrl.setListSort = type => {
    if (ctrl.accordionStatus) closeAccordions();
    ctrl.listSortReverse = (ctrl.listSort === type) ? !ctrl.listSortReverse : false;
    ctrl.listSort = type;
  };

  const closeAccordions = () => {
    Object.keys(ctrl.accordionStatus).forEach(index => {
      if (ctrl.accordionStatus[index]) {
        ctrl.accordionStatus[index] = false;
      }
    });
  };

  const startPoll = () => {
    if (!ctrl.dataFetchPromise) {
      ctrl.lastLoad = DateTime.now();
      ctrl.dataFetchPromise = $interval(triggerFetchLoad, 10000);
    }
  };

  const triggerFetchLoad = () => {
    if (ctrl.lastLoad.diffNow('seconds').seconds < -9) {
      ctrl.loadEvents();
    }
  };

  ctrl.handleAccordionToggle = (rowIndex, row) => {
    if (ctrl.accordionStatus[rowIndex]) {
      ctrl.selectedConsists.push(row.consist);
      ctrl.loadEvents();
    } else if (!ctrl.accordionStatus[rowIndex]) {
      row.events = [];
      ctrl.selectedConsists = ctrl.selectedConsists.filter(e => e !== row.consist);
    }
  };

  ctrl.openEvent = (eventItem, consist) => {
    const modalInstance = $uibModal.open({
      templateUrl: '/modules/modals/notification-module.html',
      controller: 'notificationModalController',
      windowClass: 'medium-size-modal',
      resolve: {
        notificationItem: function () {
          return eventItem;
        },
        consist: function () {
          return consist;
        },
        listType: function () {
          return 'active';
        }
      },
    });
    modalInstance.result.then(
      reload => {
        if (reload) {
          ctrl.loadEvents();
        }
      },
      () => {}
    );
  };

  // Fetch list of active events, returns data if no error.
  ctrl.fetchEvents = async params => {
    try {
      return await EventsService.getActiveFleet(params);
    } catch (e) {
      console.error(`Event fetch error: ${e}`);
      return e;
    }
  }

  // severityMapper :: (String) -> Integer 
  const severityMapper = severity => {
    const severities = {
      'Red': 1,
      'Yellow': 2,
      'White': 3,
      'default': 4
    };
    return severities[severity] || severities['default'];
  };
  
  // Maps over events list in parameter object and 
  // adds new event severity to that object. 
  // calcSeverity :: (Object) -> Object
  const calcSeverity = train => {
    if (!train.events) return;
    train.events.map(event => {
      event.severity = severityMapper(event.priority);
    });
    return train;
  };

  ctrl.loadEvents = async () => {
    ctrl.dataLoading = true;
    let data = await ctrl.fetchEvents(ctrl.selectedConsists);
    data.map(train => calcSeverity(train));
    if (data && !angular.equals(ctrl.events, data)) {
      ctrl.events = data;
      if (!ctrl.settings.fullscreen) {
        ctrl.scrollElementTop(ctrl.contentAreaId);
      }
    }
    ctrl.dataLoading = false;
  };

  ctrl.scrollElementTop = element => {
    if (element) {
      $(element).animate({ scrollTop: 0 }, 'fast');
    }
  };

  ctrl.eventColor = event => {
      return event.priority;
  };
}

angular
  .module('gridlets.module')
  .controller('ActiveEventsController', ActiveEventsController);
